module.exports = __webpack_public_path__ + "img/arloVideoDoorbell.ed6d7628.png";